module.exports = __webpack_public_path__ + "media/images/flags/mq-cdfe4378f3b9cec5d8970773af4188fe.svg";